import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerUpdateService {
  private updateAvailableSubject = new BehaviorSubject<boolean>(false);
  public updateAvailable$: Observable<boolean> = this.updateAvailableSubject.asObservable();

  constructor() { }

  setUpdateAvailable(available: boolean) {
    this.updateAvailableSubject.next(available);
  }

  isUpdateAvailable(): boolean {
    return this.updateAvailableSubject.getValue();
  }
}
